export default __webpack_public_path__ + "static/media/ssstiktok_1623214518.3c2862a0.mp4";